import { parseISO } from 'date-fns';
import { format } from 'date-fns/esm';
import { TableRowItemData } from '../../../components/Table';

export default function TableRowItem({ data }: { data: any }) {
  return (
    <>
      <TableRowItemData text={data?.createdAt ? format(parseISO(data.createdAt), 'dd/MM/yyyy') : ''} />
      <TableRowItemData text={data?.orderId} />
      <TableRowItemData text={data?.childName} />
      <TableRowItemData text={data?.email} />
      <TableRowItemData text={typeof data?.amount !== 'undefined' ? `${data?.currency} ${data.amount}` : ''} />
      <TableRowItemData text={data?.subject} />
      <TableRowItemData text={data?.paymentMethod} />
      <TableRowItemData
        component={(() => {
          const statusText = (data?.status || '').toString().toLowerCase();
          const isSuccess = statusText === 'successed' || statusText === 'succeeded' || statusText === 'success';
          const isCreated = statusText === 'created';
          const bgClass = isSuccess
            ? 'bg-green-100 text-green-700'
            : isCreated
              ? 'bg-red-100 text-red-700'
              : 'bg-gray-100 text-gray-700';
          const label = data?.status || '';
          return <span className={`px-2 py-1 rounded-md text-xs font-semibold capitalize ${bgClass}`}>{label}</span>;
        })()}
      />
    </>
  );
}
